import * as yup from 'yup'

yup.addMethod(yup.string, 'containsUppercase', function (message) {
  return this.test(
    'containsUppercase',
    message || 'Value must contain at least one uppercase letter',
    function (value) {
      return /[A-Z]+/.test(value)
    }
  )
})

yup.addMethod(yup.string, 'containsLowercase', function (message) {
  return this.test(
    'containsLowercase',
    message || 'Value must contain at least one lowercase letter',
    function (value) {
      return /[a-z]+/.test(value)
    }
  )
})

yup.addMethod(yup.string, 'containsSpecialCharacter', function (message) {
  return this.test(
    'containsSpecialCharacter',
    message || 'Value must include one of the following characters (!@#$%^&*?)',
    function (value) {
      return /[!@#$%^&*?]+/.test(value)
    }
  )
})

yup.addMethod(yup.string, 'containsNumber', function (message) {
  return this.test(
    'containsNumber',
    message || 'Value must include at least one number [0-9]',
    function (value) {
      return /[0-9]+/.test(value)
    }
  )
})

yup.addMethod(yup.string, 'isNumeric', function (message) {
  return this.test('isNumeric', message, function (value) {
    return /^[0-9]+$/.test(value)
  })
})

yup.addMethod(yup.string, 'isAlphabet', function (message) {
  return this.test('isAlphabet', message || 'You can only use alphabets [a-Z]', function (value) {
    return /^[a-zA-Z]+$/.test(value)
  })
})

export default yup
